import { useCallback, useEffect, useRef, useState } from 'react';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Botao } from '../../../components/Botao';
import { CartaoDeInformacao } from '../../../components/CartaoDeInformacao';
import { CorpoDaPagina } from '../../../components/CorpoDaPagina';
import { Input } from '../../../components/Input';
import { Modal } from '../../../components/Modal';
import { EmailStore } from '../../../stores/EmailStore';
import { Conteiner, Formulario, LinhaModal } from './styles';

function FormularioInstitucional() {
  const [editando, atribuirEditando] = useState(false);
  const [email, atribuirEmail] = useState();
  const [instituicao, atribuirInstituicao] = useState({});
  const [opcoesModal, atribuirOpcoesModal] = useState({ open: false });
  const [idSolicitacao, atribuirIdSolicitacao] = useState();

  const formRef = useRef(null);

  const { pathname } = useLocation();

  const { id } = useParams();

  const historico = useHistory();

  const enviarFormulario = useCallback(
    async (data) => {
      formRef.current?.setErrors({});
      let error = false;

      if (data.email === '') {
        formRef.current?.setFieldError('email', 'Campo obrigatório');
        error = true;
      }
      if (data.confirmarEmail === '') {
        formRef.current?.setFieldError('confirmarEmail', 'Campo obrigatório');
        error = true;
      }
      if (data.confirmarEmail !== '' && data.email !== '' && data.confirmarEmail !== data.email) {
        formRef.current?.setFieldError('confirmarEmail', 'Os emails não conferem');
        error = true;
      }

      if (error) {
        return;
      } else {
        atribuirOpcoesModal({
          open: true,
          id,
          nome: data.instituicaoEnsinoNome,
          email: data.email,
        });
      }
    },
    [historico, id],
  );

  const controlarModal = () => {
    atribuirOpcoesModal({ open: false });
  };

  const submeterFormulario = async (email) => {
    if (editando) {
      const formulario = {
        email: email,
        confirmarEmail: email,
      };

      await EmailStore.editar(formulario, idSolicitacao).then((response) => {
        if (response.status === 200) {
          toast.success('E-mail editado com sucesso!');
          historico.goBack();
        } else {
          toast.error(response.data.mensagem);
        }
      });
    } else {
      const formularioCadastro = {
        instituicaoEnsinoId: id,
        email: email,
        confirmarEmail: email,
      };

      await EmailStore.criar(formularioCadastro).then((response) => {
        if (response.status === 200) {
          toast.success('E-mail cadastrado com sucesso!');
          historico.goBack();
        } else {
          toast.error(response.data.mensagem);
        }
      });
    }
  };

  useEffect(() => {
    const callView = async () => {
      await EmailStore.obterPorId(id).then((response) => {
        if (response.status === 200) {
          atribuirEmail(response.data.email);

          if (response.data.justificativa || response.data.email === 'Não informado') {
            response.data.email = null;
          }
          atribuirInstituicao(response.data);
          atribuirIdSolicitacao(response.data.id);
        } else {
          toast.error(response.data.mensagem);
          historico.goBack();
        }
      });
    };

    callView();
  }, [pathname, id]);

  useEffect(() => {
    const contemPalavra = pathname.includes('editar');
    atribuirEditando(contemPalavra);
  }, []);

  const acoesModal = (
    <>
      <Botao
        texto='Cancelar'
        aoClicar={() => atribuirOpcoesModal({ open: false })}
        cor='danger'
        outlined
      />
      <Botao texto='Confirmar' aoClicar={() => submeterFormulario(opcoesModal.email)} />
    </>
  );

  return (
    <CorpoDaPagina titulo={`Instituição ${id}`} voltar>
      <Conteiner>
        {instituicao.status === 'E-mail reprovado' ? (
          <CartaoDeInformacao
            titulo={`Justificativa da recusa do email (${email})`}
            texto={instituicao.justificativa ? instituicao.justificativa : 'Motivo não informado.'}
            tipo={'erro'}
          />
        ) : (
          <CartaoDeInformacao
            texto={
              'O email inserido abaixo deve ser um email institucional, que será futuramente o contato com a instituição de ensino.'
            }
            tipo={'alerta'}
          />
        )}

        <Formulario ref={formRef} onSubmit={enviarFormulario} initialData={instituicao}>
          <Input titulo='Nome da instituição' nome='instituicaoEnsinoNome' desabilitado />
          <Input
            titulo='E-mail'
            nome='email'
            tipo='email'
            placeholder={'Insira o e-mail da instituição'}
            valorMaximo={100}
          />
          <Input
            titulo='Confirmar e-mail'
            nome='confirmarEmail'
            tipo='email'
            placeholder={'Confirme o e-mail da instituição'}
            valorMaximo={100}
            proibirColar
          />
          <Botao tipo='submit' texto='Salvar' cor='primary' />
        </Formulario>
      </Conteiner>

      {opcoesModal.open && (
        <Modal
          titulo='Confirmação de dados'
          acoes={acoesModal}
          controleAberturaModal={controlarModal}
        >
          <LinhaModal>
            Você está adicionando como email institucional
            <span id='destaqueModal'>&quot;{opcoesModal.email}&quot;</span> para a instituição{' '}
            <span id='destaqueModal'>&quot;{opcoesModal.nome}&quot;</span>
          </LinhaModal>
          <LinhaModal>Deseja confirmar os dados inseridos?</LinhaModal>
        </Modal>
      )}
    </CorpoDaPagina>
  );
}

export default FormularioInstitucional;
